// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A5Bc","top":"styles_top__qr_PE"};